module.exports = __webpack_public_path__ + "img/responsive hospitium-12.bcd6fd8d.jpg";